function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsCompliance = function SvgSettingsCompliance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.75,19.57V31.94a1.69,1.69,0,0,1-1.69,1.69H19.94a1.69,1.69,0,0,1-1.69-1.69V19.57a1.69,1.69,0,0,1,1.69-1.69h2.81a2.25,2.25,0,0,1,4.5,0h2.81A1.69,1.69,0,0,1,31.75,19.57ZM25,17a.84.84,0,1,0,.84.84A.83.83,0,0,0,25,17",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,22.06a.21.21,0,0,0-.29,0h0l-1.12,1.11-.4-.38a.2.2,0,0,0-.3,0h0l-.28.27a.22.22,0,0,0,0,.3h0l.84.83a.21.21,0,0,0,.31,0l.27-.27,1.27-1.27a.22.22,0,0,0,0-.3Zm0,2.8a.21.21,0,0,0-.29,0h0L21.54,26l-.4-.39a.22.22,0,0,0-.3,0h0l-.28.28a.22.22,0,0,0,0,.3h0l.84.83a.23.23,0,0,0,.31,0l.27-.27,1.27-1.27a.22.22,0,0,0,0-.3Zm-1.33,3.05a.84.84,0,1,0,.85.84A.85.85,0,0,0,21.62,27.91Zm7.6.28H24.16a.28.28,0,0,0-.29.28V29a.28.28,0,0,0,.29.28h5.06A.28.28,0,0,0,29.5,29v-.56A.28.28,0,0,0,29.22,28.19Zm0-5.63H24.16a.29.29,0,0,0-.29.28v.57a.29.29,0,0,0,.29.28h5.06a.29.29,0,0,0,.28-.28v-.57A.29.29,0,0,0,29.22,22.56Zm0,2.82H24.16a.28.28,0,0,0-.29.28v.56a.29.29,0,0,0,.29.28h5.06a.29.29,0,0,0,.28-.28v-.56A.28.28,0,0,0,29.22,25.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsCompliance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-compliance.457bb9a1.svg";
export { ForwardRef as ReactComponent };